import { Card, Row, Col, Alert, Typography } from "antd"
import HighchartsReact from "highcharts-react-official"
import Highcharts from "highcharts"
const { Title, Text } = Typography

// Chart configurations
const forecastChartOptions = {
  chart: {
    type: "line",
    height: 300,
  },
  title: {
    text: null,
  },
  xAxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
  },
  yAxis: {
    title: {
      text: "Revenue ($K)",
    },
  },
  series: [
    {
      name: "Baseline Forecast",
      data: [10000, 11000, 12000, 12500, 13000, 13500],
      dashStyle: "Dash",
      color: "#94a3b8",
    },
    {
      name: "Risk-Adjusted",
      data: [9800, 10200, 11800, 12100, 12400, 12800],
      color: "#ef4444",
      lineWidth: 2,
    },
    {
      name: "Actual",
      data: [9750, 10100, 11900, null, null, null],
      color: "#22c55e",
      lineWidth: 2,
    },
  ],
  tooltip: {
    formatter: function () {
      return `<b>${this.series.name}</b><br/>${this.x}: $${(this.y / 1000).toFixed(0)}K`
    },
  },
  legend: {
    enabled: true,
  },
}

const riskAllocationChartOptions = {
  chart: {
    type: "pie",
    height: 300,
  },
  title: {
    text: null,
  },
  series: [
    {
      name: "Risk Allocation",
      data: [
        { name: "Supply Chain", y: 30, color: "#ef4444" },
        { name: "Regulation", y: 25, color: "#f97316" },
        { name: "Pricing", y: 20, color: "#eab308" },
        { name: "Technology", y: 15, color: "#3b82f6" },
        { name: "Market", y: 10, color: "#8b5cf6" },
      ],
    },
  ],
  tooltip: {
    formatter: function () {
      return `<b>${this.point.name}</b>: ${this.y}%`
    },
  },
  plotOptions: {
    pie: {
      dataLabels: {
        enabled: true,
        format: "{point.name}: {point.y}%",
      },
    },
  },
}

const RiskSection = () => {
  return (
    <Row gutter={[24, 24]} style={{ marginBottom: "24px" }}>
          {/* Risk/Opportunity-Weighted Forecast */}
          <Col xs={24} lg={12}>
            <Card>
              <Title level={4}>
                Risk/Opportunity-Weighted Forecast
              </Title>
              <Text type="secondary">Adjusted future revenue based on incoming threat & opportunity signals</Text>

              <Alert
                message={
                  <span>
                    <Text strong>Baseline Q3 forecast:</Text> $12M →{" "}
                    <Text strong style={{ color: "#ff4d4f" }}>
                      Adjusted: $9.4M
                    </Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      (due to unaddressed vendor risk + missed growth trend)
                    </Text>
                  </span>
                }
                type="warning"
                style={{ margin: "16px 0" }}
              />

              <HighchartsReact highcharts={Highcharts} options={forecastChartOptions} />
            </Card>
          </Col>

          {/* Category Risk Allocation */}
          <Col xs={24} lg={12}>
            <Card>
              <Title level={4}>Category Risk Allocation</Title>
              <Text type="secondary">% of projected financial exposure across categories</Text>

              <HighchartsReact highcharts={Highcharts} options={riskAllocationChartOptions} />
            </Card>
          </Col>
        </Row>
  )
}

export default RiskSection